import { useState } from "react";
import { Sheet } from "src/core/components/sheet/Sheet";
import { SanitisedHtml } from "src/core/components/SanitisedHtml";
import { DateDisplay } from "src/core/components/data/DateDisplay";
import { usePrivacyPolicy } from "src/core/church/useChurchTexts";

interface Props {
    open: boolean;
    onClose(): void;
}

export const PrivacyPolicySheet = ({ open, onClose }: Props) => {
    // Fetched only once the sheet has first been opened
    const [opened, setOpened] = useState(false);
    if (open && !opened) setOpened(true);

    const { policy, error } = usePrivacyPolicy(opened);

    return (
        <Sheet
            open={open}
            onClose={onClose}
            title="Privacy policy"
            subtitle={
                policy && (
                    <>
                        Last updated <DateDisplay date={policy.publishedAt} format="LONG" />
                    </>
                )
            }
        >
            {policy ? (
                <SanitisedHtml html={policy.body} className="prose px-1" />
            ) : error ? (
                <p className="px-1">
                    There was an error loading the privacy policy. Try again, or contact the church for help.
                </p>
            ) : (
                <span className="loading loading-spinner" />
            )}
        </Sheet>
    );
};
